import { render, staticRenderFns } from "./BulletListItem.vue?vue&type=template&id=a96282e0&"
import script from "./BulletListItem.vue?vue&type=script&lang=js&"
export * from "./BulletListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports